import { render, staticRenderFns } from "./eventAdd.vue?vue&type=template&id=f95323ec&scoped=true&"
import script from "./eventAdd.vue?vue&type=script&lang=js&"
export * from "./eventAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95323ec",
  null
  
)

export default component.exports